import {
  AllegroImpliedWarranties,
  AllegroFullImpliedWarranty,
} from './impliedWarrantyTypes';

export const mockAllegroImpliedWarranty: AllegroFullImpliedWarranty = {
  id: '9a908d1f-dd30-4c30-87ad-b82ce5d696b8',
  seller: {
    id: '12345',
  },
  name: 'Standardní reklamační podmínky',
  individual: {
    period: 'P2Y',
  },
  corporate: {
    period: 'P1Y',
  },
  address: {
    name: 'Sklad Allegro',
    street: 'Václavské náměstí 1',
    postCode: '110 00',
    city: 'Praha',
    countryCode: 'CZ',
  },
  description: 'Reklamační podmínky platí pro všechny zboží zakoupené v našem obchodě.',
};

export const mockGetAllegroImpliedWarranties: AllegroImpliedWarranties = {
  impliedWarranties: [
    {
      id: '9a908d1f-dd30-4c30-87ad-b82ce5d696b8',
      name: 'Warranty 1',
    },
    {
      id: 'f2cc80e9-d7bc-42d0-9d4e-c3f38789b006',
      name: 'Warranty 2',
    },
    {
      id: '637ba234-76a9-4bfe-b5fe-bad3e6389fe3',
      name: 'Warranty 3',
    },
    {
      id: 'd1a9cbe2-c61c-4dba-a107-f88a96575f7e',
      name: 'Warranty 4',
    },
    {
      id: '8a56a90c-d5e1-4c34-96dc-92447b749fa5',
      name: 'Warranty 5',
    },
  ],
  count: 5,
};
